<div *ngIf="regionSlug && region">

  <!-- Hero -->
  <div class="section-hero" [style]="{'background-image': 'url(/images/splash-regional/' + regionSlug + '.jpg)'}">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-9 col-xxl-8">
          <div class="title-panel">
            <h1>Drop in to beautiful workspaces all around {{ region.name }}</h1>
            <br/>
            <h2>Croissant gives you by-the-minute access to coworking spaces</h2>
            <br/>
            <a class="btn btn-join" routerLink="/join/details">Get Started Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Steps -->
  <div class="section-steps">
    <br/>
    <br/>
    <br/>

    <!-- Not mobile -->
    <div class="hide-sm hide-md">
      <div class="container">
        <div class="row">

          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div class="row">
              <div class="col-12 col-md-5 col-lg-5 col-xl-4">
                <picture>
                  <source srcset="/images/splash-regional/iphone6.webp" type="image/webp">
                  <img src="/images/splash-regional/iphone6.png" class="img-responsive workspace-image" alt="Croissant mobile app on iPhone"/>
                </picture>
              </div>
              <div class="col-12 col-md-7 col-lg-7 col-xl-8" style="padding-left: 40px">
                <h2>How it works</h2>
                <br/>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">1</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Choose from thousands of seats</h3>
                    <p>Find a space nearby to meet, work, &amp; focus on your projects.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">2</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Check in with the app</h3>
                    <p>Drop by when you need the space and check in for instant access.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">3</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Plug in and get to work</h3>
                    <p>Fast wifi, coffee, plugs, and like-minded people at each space.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="hide-lg hide-xl hide-xxl">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>How it works</h2>
            <br/>
            <h3>1. Choose from thousands of seats</h3>
            <p>Find a space nearby to meet, work, &amp; focus on your projects.</p>
            <h3>2. Check in with the app</h3>
            <p>Drop by when you need the space and check in for instant access.</p>
            <h3>3. Plug in and get to work</h3>
            <p>Fast wifi, coffee, plugs, and like-minded people at each space.</p>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Places -->
  <div class="section-places">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col text-center">
          <h2>Meet, work, & focus at these spaces</h2>
          <br/>
          <br/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xxl-10 offset-xxl-1">
          <div class="row">
            <div class="col-6 col-md-6">
              <div class="place-panel" *ngIf="places.length > 0 && places[0].smallImages.length > 0">
                <img class="img-responsive" [src]="places[0].smallImages[0].filePath" [alt]="places[0].name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ places[0].name }}</h3>
                  <small class="place-detail-neighborhood">{{ places[0].location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 col-md-6">
              <div class="place-panel" *ngIf="places.length > 1 && places[0].smallImages.length > 0">
                <img class="img-responsive" [src]="places[1].smallImages[0].filePath" [alt]="places[1].name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ places[1].name }}</h3>
                  <small class="place-detail-neighborhood">{{ places[1].location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 col-md-4">
              <div class="place-panel" *ngIf="places.length > 2 && places[0].smallImages.length > 0">
                <img class="img-responsive" [src]="places[2].smallImages[0].filePath" [alt]="places[2].name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ places[2].name }}</h3>
                  <small class="place-detail-neighborhood">{{ places[2].location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 col-md-4">
              <div class="place-panel" *ngIf="places.length > 3 && places[0].smallImages.length > 0">
                <img class="img-responsive" [src]="places[3].smallImages[0].filePath" [alt]="places[3].name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ places[3].name }}</h3>
                  <small class="place-detail-neighborhood">{{ places[3].location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-12 col-md-4 hide-sm hide-md">
              <div class="place-panel" *ngIf="places.length > 4 && places[0].smallImages.length > 0">
                <img class="img-responsive" [src]="places[4].smallImages[0].filePath" [alt]="places[4].name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ places[4].name }}</h3>
                  <small class="place-detail-neighborhood">{{ places[4].location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Pricing -->
  <div class="section-pricing">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <h1>Crystal clear pricing</h1>
            <br/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xxl-10 offset-xxl-1">
          <app-pricing-boxes [regionSlug]="regionSlug" [isHideRegionSelection]="true"></app-pricing-boxes>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Reviews -->
  <div class="section-review">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2>Why remote workers use Croissant</h2>
              </div>
            </div>
          </div>

          <br/>
          <br/>

          <div class="row">
            <div class="col-12 col-md-6">
              <p>"All the good vibes of a cafe...without being subject to a cafe's music, prices or the random patron who asks: 'Hey dude, you writing a screenplay, too?'"</p>
              <h3>Bryan L, Freelance Journalist</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6">
              <p>"I love the fact that I can drop into spaces for two hours and then get up and go somewhere else to a meeting, and then wherever I am, look at the map, and be by a new space."</p>
              <h3>Ava R, Strategy Consultant</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6">
              <p>"Croissant moves straight to my home screen when I’m in the US for work. Different office every day is awesome."</p>
              <h3>Jeremy B, Founder of Emojipedia</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"it's an office anywhere you need it in the city for far less than you'd pay for a co-working membership. If you don't need a desk 9-5 everyday, I'd highly recommend checking it out."</p>
              <h3>Justin G, Attorney</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"I love croissant &#60;3 You just need to check in on the app and say that you are a Croissant member to the front desk and you can feel free to work."</p>
              <h3>Laura W, Engineer at Spotify</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"My colleague and I are loving the ability to jump around from different locations in the city and explore beautiful new creative spaces."</p>
              <h3>Jessica P, Creative Director at JPD Studios</h3>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Images -->
  <div class="section-images">
    <div class="container-fluid g-0">
      <div class="row g-0">
        <div class="col-12 col-sm-6">
          <picture>
            <source srcset="/images/splash-regional/place-bond.webp" type="image/webp">
            <img src="/images/splash-regional/place-bond.jpg" class="img img-responsive" alt="Bond coworking space"/>
          </picture>
        </div>
        <div class="col-12 col-sm-6 hide-sm">
          <picture>
            <source srcset="/images/splash-regional/place-impacthub.webp" type="image/webp">
            <img src="/images/splash-regional/place-impacthub.jpg" class="img img-responsive" alt="Impact Hub coworking space"/>
          </picture>
        </div>
      </div>
    </div>
  </div>

</div>




